import { render, staticRenderFns } from "./service-form.vue?vue&type=template&id=514146d5"
import script from "./service-form.vue?vue&type=script&lang=js"
export * from "./service-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports